export default __webpack_public_path__ + "static/media/cristian.69023a2a.jpg";